import { useRef } from 'react';

import useAnimate from '@Hotels-at-Home/hah-fe-core/dist/hooks/useAnimate';
import HeroSection from './sections/HeroSection';
import FretteSection from './sections/FretteSection';
import BedSection from './sections/BedSection';
import BeddingSection from './sections/BeddingSection';
import AmenitiesSection from './sections/AmenitiesSection';
import RobeSection from './sections/RobeSection';
import BathSection from './sections/BathSection';
import FragranceSection from './sections/FragranceSection';
import SignatureSection from './sections/SignatureSection';
import SeoSection from './sections/SeoSection';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';

interface IProps {
  promotion: IGetPromotionResponse;
}

const Home = ({ promotion }: IProps) => {
  const animateRef = useRef(null);
  useAnimate(animateRef);

  return (
    <div id="home" ref={animateRef}>
      <HeroSection promotion={promotion} />
      <FretteSection />
      <BedSection />
      <BeddingSection />
      <AmenitiesSection />
      <RobeSection />
      <BathSection />
      <FragranceSection />
      <SignatureSection />
      <SeoSection />
    </div>
  );
};

export default Home;
